/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Title_RequiredInputs */

const cs_blog_title_required = /** @type {(inputs: Blog_Title_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Český nadpis je povinný.`)
};

const en_blog_title_required = /** @type {(inputs: Blog_Title_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czech title is required.`)
};

/**
* | output |
* | --- |
* | "Czech title is required." |
*
* @param {Blog_Title_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_title_required = /** @type {((inputs?: Blog_Title_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Title_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_title_required(inputs)
	return cs_blog_title_required(inputs)
});